import { render, staticRenderFns } from "./DocumentPage.component.pug?vue&type=template&id=4a367cda&scoped=true&lang=pug&"
import script from "./DocumentPage.component.ts?vue&type=script&lang=ts&"
export * from "./DocumentPage.component.ts?vue&type=script&lang=ts&"
import style0 from "./DocumentPage.component.scss?vue&type=style&index=0&id=4a367cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a367cda",
  null
  
)

export default component.exports